import { render, staticRenderFns } from "./UsuariosForm.vue?vue&type=template&id=5f304129&scoped=true&lang=pug&"
import script from "./UsuariosForm.vue?vue&type=script&lang=js&"
export * from "./UsuariosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f304129",
  null
  
)

export default component.exports